var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('span',{staticClass:"fixed-div"},[_c('h1',[_vm._v(_vm._s(_vm.counter))])]),_c('button',{on:{"click":_vm.startCountdown}},[_vm._v("Iniciar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }